import Vue from 'vue'
import Vuex from 'vuex'
import { isDisponivelNoHorario, normalizeCardapioProdutos } from '../../../helpers/cardapio-helper'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dataUser: {},
    empresaAberta: null,
    base_url: '',
    empresa: {
      horarios: [],
      entregas: [],
      agendamentos: [],
      destaques: [],
      gtags: []
    },
    isFranquia: false,
    sacola: { produtos: [] },
    nolocal: { obs_pedido: '', onde_estou: '' },
    cardapio: {
      categorias: [],
      destaques: [],
      produtos: [],
      promocoes: [],
      url: '/',
    },
    cidade: {},
    load: false,
    modalPush: 0,
    cartao_pagamento: null,
    url: '',
    beneficios: [],
    recomendados: [],
    saldoFidelidade: null,
    pontosSacola: 0,
    id_theme: '1',
    taxa: null,
    pwaPrompt: null,
    placesUnavailable: false,
    agendamentoDefinido: false
  },

  mutations: {
    setDataUser: (state, data) => {
      localStorage.setItem('token', data.token);
      state.dataUser = data.dados;
      state.taxa = null;
    },

    setEmpresa: (state, data) => {
      state.empresa = data;
      state.base_url = data.server + data.token + '/';
      state.empresa.zonas = (data.zonas || []);
      const cartao = (data.pagamentos || []).find(pag => ['30', '32'].includes(pag.id_pagamento));
      state.cartao_pagamento = cartao ? cartao.id_pagamento : null;
    },

    logout(state) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('cuponsReadonly');
      state.saldoFidelidade = null;
      state.sacola = { produtos: [], origin: '1' };
      state.agendamentoDefinido = false;
      state.dataUser = {};
    },

    setCardapio(state, data) {
      const now = data.now || null;
      const categorias = data.cardapio?.categorias || [];
      const categoriasFiltradas = categorias.filter(categoria =>
        categoria.disponibilidade === '1' || isDisponivelNoHorario(categoria, now)
      );
      const destaquesFiltrados = (data.cardapio?.destaques || []).filter(destaque =>
        isDisponivelNoHorario(destaque, now)
      );
      const cardapioNormalizado = normalizeCardapioProdutos(categoriasFiltradas);

      state.cardapio.destaques = destaquesFiltrados;
      state.cardapio.categorias = cardapioNormalizado.categorias;
      state.cardapio.produtos = cardapioNormalizado.produtos;
      state.cardapio.promocoes = cardapioNormalizado.promocoes;
    },

    setProdutosSacola(state, data) {
      let total = 0;
      let pontos = 0;

      if (data.token !== state.empresa.token) {
        let expiracao = state.nolocal.expiracao || (new Date().getTime() + ((1000 * 60 * 60) * 24));
        state.sacola = {
          token: state.empresa.token,
          empresa: state.empresa.nome_fantasia,
          dominio_delivery: state.empresa.dominio_delivery,
          origin: data.origin || null,
          nolocal: data.nolocal || null,
          produtos: data.produtos,
          cliente: {},
          id_pagamento: '',
          tipo_pedido: '',
          valor_frete: 0,
          id_cupom: '',
          total: 0,
          troco: 0,
          obs_pedido: '',
          expiracao
        }
      }

      state.sacola.produtos.forEach(p => {
        total += (p.quantidade * parseFloat(p.valor));
        pontos += (!isNaN(p.pontos) ? parseInt(p.pontos) : 0);
      });

      state.sacola.total = total;
      state.pontosSacola = pontos;
      localStorage.setItem('sacola', JSON.stringify(state.sacola));
    },

    clearSacola(state) {
      state.sacola.produtos = [];
      state.sacola.origin = '1';
      state.agendamentoDefinido = false;
    },

    setPrompt(state, data) {
      state.pwaPrompt = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
